module.exports = __webpack_public_path__ + "images/ca2ceddcd9c28a22c449286f3fe66751.png";